import styled, { css } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { Divider } from '@/components/UI/Divider/Divider.styles';
import { CustomLink } from '@/components/CustomLink/CustomLink';
import { getMaskIconStyles } from '@/styles/helpers';

export const FooterBox = styled.footer<{ $isFullWidth?: boolean }>`
  padding: 40px calc((100% - 1280px) / 2) 15px;
  background-color: #fff;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100vw;
    height: 1px;
    background-color: ${({ theme }) => theme.palette.secondary.border};
  }

  @media (max-width: 1300px) and (min-width: 950px) {
    padding: 40px 40px 15px;
  }
  @media (max-width: 949px) and (min-width: 320px) {
    display: none;
  }
`;

export const FooterTopContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  gap: 15px;
`;

export const FooterTop = styled.div`
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  gap: 15px;
`;

export const FooterLinks = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 20px 0 40px;
  > a {
    max-width: max-content;
  }
  @media (max-width: 1300px) and (min-width: 500px) {
    flex-direction: column;
  }
`;

export const FooterInfo = styled.div`
  display: flex;
  column-gap: 60px;
  row-gap: 20px;
  flex-wrap: wrap;

  a {
    transition: color 0.1s linear;

    &:hover {
      color: ${({ theme }) => theme.palette.brand.main};
    }
  }
`;

export const FooterSocials = styled.div`
  display: flex;
  gap: 10px;
`;

export const FooterSocial = styled.a<{ $iconName: string }>`
  display: block;
  height: 20px;
  width: 20px;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  background-image: ${({ $iconName }) => `url('/images/${$iconName}.svg')`};
`;

export const FooterSiteVersions = styled.div`
  display: flex;
  align-items: baseline;
  gap: 15px;
`;

export const FooterPhones = styled.div`
  margin-bottom: 10px;
`;

export const FooterResponsibility = styled(Typography.Caption)`
  max-width: 85%;
  margin: 15px 0 0;
`;

export const FooterDivider = styled(Divider)`
  margin: 20px 0;
  background-color: ${({ theme }) => theme.palette.secondary.border};
`;

export const PhoneNumber = styled(Typography.Numbers)`
  color: ${({ theme }) => theme.palette.secondary.labels};
  transition: color 0.1s linear;

  &:hover {
    color: ${({ theme }) => theme.palette.brand.main};
  }
`;

export const MailAddress = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.secondary.labels};
  transition: color 0.1s linear;

  &:hover {
    color: ${({ theme }) => theme.palette.brand.main};
  }
`;

export const FooterChangeLang = styled.div`
  position: relative;
  display: flex;
  margin-right: 45px;
  &::before {
    content: '';
    display: block;
    margin-right: 10px;
    background-color: ${({ theme }) => theme.palette.secondary.labels};

    ${getMaskIconStyles('language.svg')};
  }

  @media (max-width: 1300px) and (min-width: 500px) {
    width: 100%;
    padding-bottom: 30px;
  }
`;

const RegionsList = css`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(12.5%, 1fr));
  grid-gap: 10px;
  padding: 0;
  margin: 0;
  list-style: none;
  grid-auto-flow: column;
`;

export const Regions = styled.div`
  display: flex;
  width: 100%;
  margin: 0 auto;
  max-width: 1280px;
  flex-direction: column;
`;

export const TopRegions = styled.ul`
  ${RegionsList};
  grid-template-rows: repeat(2, auto);
  margin-bottom: 32px;
`;

export const OtherRegions = styled.ul`
  ${RegionsList};
  grid-template-rows: repeat(9, auto);
  margin-bottom: 60px;
`;

export const RegionLink = styled(CustomLink)`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.secondary.labels};
  text-decoration: none;
  transition: color 0.1s linear;

  &:hover {
    color: ${({ theme }) => theme.palette.brand.main};
  }
`;
